import ProtectedRoute from '../../components/ProtectedRoute';
import DocumentationPage from './components/DocumentationPage';

import { DOCUMENTATION_PATH } from '../../constants/routes';

const Routes = [
  {
    path: DOCUMENTATION_PATH,
    Component: ProtectedRoute,
    children: [
      {
        index: true,
        Component: DocumentationPage,
      },
    ],
  },
];

export default {
  Routes,
};
